/**
 * Main App Component
 * Handles routing and global providers
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { I18nProvider } from './i18n/I18nContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';

// Pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import KvkkPage from './pages/KvkkPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import VerifyEmail from './pages/VerifyEmail';

// Admin pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminVerifyOtp from './pages/admin/AdminVerifyOtp';
import AdminDashboard from './pages/admin/AdminDashboard';

// Components
import CookieBanner from './components/CookieBanner';

// Styles
import './styles/App.css';
import './styles/Admin.css';

function App() {
    return (
        <Router>
            <I18nProvider>
                <AuthProvider>
                    <AdminAuthProvider>
                        <div className="App">
                        <CookieBanner />
                        <Routes>
                            {/* Public Routes */}
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/verify-email" element={<VerifyEmail />} />

                            {/* Legal Pages */}
                            <Route path="/kvkk" element={<KvkkPage />} />
                            <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
                            <Route path="/kullanim-kosullari" element={<TermsOfService />} />
                            <Route path="/cerez-politikasi" element={<CookiePolicy />} />

                            {/* Protected User Routes */}
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/profile" element={<Navigate to="/dashboard?tab=account" replace />} />

                            {/* Admin Routes */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin/verify" element={<AdminVerifyOtp />} />
                            <Route
                                path="/admin"
                                element={
                                    <AdminProtectedRoute>
                                        <AdminDashboard />
                                    </AdminProtectedRoute>
                                }
                            />

                            {/* 404 Not Found */}
                            <Route
                                path="*"
                                element={
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '50px',
                                        fontSize: '24px'
                                    }}>
                                        404 - Page Not Found
                                    </div>
                                }
                            />
                        </Routes>
                        </div>
                    </AdminAuthProvider>
                </AuthProvider>
            </I18nProvider>
        </Router>
    );
}

export default App;